var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.triState && _vm.value === null)?_c('span',{staticClass:"text-secondary"},[_c('i',{staticClass:"material-icons"},[_vm._v("remove")])]):(_vm.value)?_c('span',{class:_vm.colorTrue},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])]):_c('span',{class:_vm.colorFalse},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])
}
var staticRenderFns = []

export { render, staticRenderFns }